<div *ngIf="!showCamera" class="img-scan">
    <img src="{{session?.user?.isStoreCustomer? 'assets/images/fondoscan2.jpg' : 'assets/images/fondoscan.jpg'}}" class="w-100">
    <div class="img-content" [ngStyle]="{'top': session?.user?.isStoreCustomer ? '62%' : '68%'}">
        <div class="d-flex-center">
            <div class="font-18 text-center" style="font-weight: 500; width: 60%;">Escaneá un QR para descubrir el contenido</div>
        </div>
        <!-- Usuario normal -->
        <div *ngIf="!session?.user?.isStoreCustomer" class="d-flex-center m-t-40">
            <div class="btn-scan" (click)="showCamera = true">
                <span class="mr-2">Escanear QR</span>
                <i class="mdi mdi-camera-outline" style="font-size: 24px; height: 33px;"></i>
            </div>
        </div>
        <!-- Usuario autorizado de comercio -->
        <div *ngIf="session?.user?.isStoreCustomer" class="d-flex flex-column align-items-center m-t-30">
            <div>
                <div class="btn-scan" (click)="goToGSA()">
                    <span class="mr-2">Scan de Comercio</span>
                    <i class="mdi mdi-camera-outline" style="font-size: 24px; height: 33px;"></i>
                </div>
            </div>
            <div class="m-t-30">
                <div class="btn-scan-dark" (click)="showCamera = true">
                    <span class="mr-2">Escanear QR</span>
                    <i class="mdi mdi-camera-outline text-primary" style="font-size: 24px; height: 33px;"></i>
                </div>
            </div>
            
        </div>  
    </div> 
</div>

<div *ngIf="showCamera" class="p-t-20" style="background-color: #1A1B27;">
    <div class="d-flex-center">
        <!-- Cámara -->
        <div class="scanner-container">
            <div class="blur-overlay top"></div>
            <div class="blur-overlay bottom"></div>
            <div class="blur-overlay left"></div>
            <div class="blur-overlay right"></div>
            <div class="scanner-focus"></div>
            <zxing-scanner [formats]="['QR_CODE', 'CODE_128']" (scanSuccess)="scanSuccessHandler($event)"></zxing-scanner>
        </div>
    </div>
    <div class="d-flex-center">
        <div class="btn-close m-t-20 m-b-20" (click)="showCamera = false">
            <i class="mdi mdi-close-thick" style="font-size: 24px;"></i>
        </div>
    </div>
</div>  

<!-- Play the scratch-->
<ng-container *ngIf="selectedScratch">
    <app-play-scratch [selectedScratch]="selectedScratch" [country]="country" [uniqueLinkCode]="uniqueLinkCode" (onCloseEvent)="onCloseScratch()"></app-play-scratch>
</ng-container>

<!-- Change country -->
<ng-template #changeCountryModal let-modal>
    <div class="p-20">
        <div class="font-14 font-bold text-center">Este QR es exclusivo de Givi {{country == 1 ? 'Costa Rica' : 'Panama'}}, cambia el país para poder escanearlo.</div>

        <div class="d-flex-center m-t-10">
            <img src="assets/images/sinBeneficios.png" style="width: 50%;">
        </div>

        <!-- Country select -->
        <div class="d-flex-center align-items-center m-t-10">
            <img *ngIf="selectedCountry" [src]="selectedCountry.img" class="country-flag" alt="{{ selectedCountry.name }}" />
            <div class="font-12 text-center">
                Estás Viendo Givi            
            </div>
            <div class="country-select">
                <div class="selected-country" (click)="toggleDropdown()">
                    <span class="font-12 font-bold ml-2" style="text-decoration: underline;">{{ selectedCountry ? selectedCountry.name : 'Seleccionar País' }}</span>
                    <i class="mdi mdi-chevron-down" style="font-size: 24px;"></i>
                </div>
                <div class="dropdown" *ngIf="dropdownOpen">
                    <div 
                        class="dropdown-option" 
                        *ngFor="let country of countries" 
                        (click)="selectCountry(country)">
                        <img [src]="country.img" class="country-flag" alt="{{ country.name }}" />
                        <span>{{ country.name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-t-10 text-center" (click)="modalService.dismissAll()">
            <div class="font-12 text-muted">Cerrar</div>
        </div>
    </div>
</ng-template>